import { useQuery } from "@tanstack/react-query";

import { getPlatformContracts } from "services";

import { GET_PLATFORM_CONTRACTS_ADMIN } from "consts";

import { PlatformContract } from "models";

export const useGetPlatformContractsAdmin = () =>
  useQuery<PlatformContract[]>({
    queryKey: [GET_PLATFORM_CONTRACTS_ADMIN],
    queryFn: () => getPlatformContracts(),
  });
